import {
    REGISTER_SUCCESS,
    REGISTER_FAIL,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT,
    SET_GAMES,
    QR_SESSION_REQUEST,
    QR_SESSION_REQUEST_FAILED,
    QR_SESSION_CHECK,
    QR_SESSION_CHECK_FAIL,
    QR_SESSION_LOGIN,
    QR_SESSION_LOGIN_FAIL,
    GET_LATEST_OPEN_ROOM_ID,
    GET_LATEST_OPEN_ROOM_ID_FAILED,
    IMPERSONATE_LOGIN,
    IMPERSONATE_LOGOUT,
    SESSION_ENDED,
    SESSION_ENDED_CLEAR,
    SESSION_CONFLICT,
    SESSION_CONFLICT_CLEAR,

} from "actions/types";
import { leaveRoom, } from "actions/room";
import AuthService from "services/auth";
import Store from "store/reduxstore";
import Analytics from "analytics";

export const register = (email, password, country) => (dispatch) => {
    return AuthService.register(email, password, country).then(
        (response) => {
            if (response.status == "Error") {
                const message =
                    response.message ||
                    response.message.toString();

                let list = null;
                if (response.messageList) {
                    list = response.messageList
                }

                return Promise.reject(message);
            }
            else {
                dispatch({
                    type: REGISTER_SUCCESS,
                });

                return response;
            }
        },
        (error) => {
            const messageError =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();

            dispatch({
                type: REGISTER_FAIL,
            });

            return Promise.reject(messageError);
        }
    );
};

/**
 * Logs in a user using email/password or an external provider.
 *
 * @param {Object} req - The login request object.
 * @param {string} [req.provider] - The external provider name (e.g., "google"). If not provided, email/password login is used.
 * @param {string} [req.email] - The user's email address (required for email/password login).
 * @param {string} [req.password] - The user's password (required for email/password login).
 * @param {string} [req.idToken] - The external provider ID token (required for external login).
 * @param {string} [req.QRSessionID] - Optional QR session ID for device login.
 * @param {string} [req.country] - Optional country code.
 * @returns {Promise<Object>} Resolves with user data on success, or error data on failure.
 */
export const login = (req) => (dispatch) => {
    console.log("do login");
    return AuthService.login(req).then(
        (response) => {
            // Handle session conflict (409)
            if (response.status === "SessionConflict") {
                dispatch({
                    type: SESSION_CONFLICT,
                    payload: {
                        message: response.message,
                        activeSessions: response.activeSessions,
                        sessionType: response.sessionType,
                    },
                });
                return Promise.reject("SessionConflict");
            }

            if (response.isAuthenticated === true) {
                Analytics.login();

                dispatch({
                    type: LOGIN_SUCCESS,
                    payload: { user: response },
                });
                //dispatch(getPackOwnership());

                return Promise.resolve();
            }
            else {
                const messageRes = response.message
                console.log(messageRes);

                dispatch({
                    type: LOGIN_FAIL,
                });

                return Promise.reject(messageRes);
            }
        },
        (error) => {
            const messageError = getErrorMessage(error);

            console.log(messageError);

            dispatch({
                type: LOGIN_FAIL,
            });

            return Promise.reject();
        }
    );
};

export const requestQRSession = (oldSessionID, ttl, originSessionType) => (dispatch) => {
    console.log("Requesting QR Login Session");
    return AuthService.requestQRSession(oldSessionID, ttl, originSessionType).then(
        (response) => {
            dispatch({
                type: QR_SESSION_REQUEST,
                payload: { QRSession: response },
            });

            return response;
        },
        (error) => {
            const messageError = getErrorMessage(error);
            console.log(messageError);

            dispatch({
                type: QR_SESSION_REQUEST_FAILED,
            });

            return Promise.reject();
        });
}

export const getQRSession = (QRSessionID) => (dispatch) => {
    console.log("checking QR Login Session");
    return AuthService.getQRSession(QRSessionID).then(
        (response) => {
            const sessionData = { sessionID: response.sessionID, expires: response.expires };
            const userData = response.user;

            if (userData) dispatch({
                type: QR_SESSION_LOGIN,
                payload: {
                    QRSession: sessionData,
                    user: userData
                },
            });
            else dispatch({
                type: QR_SESSION_CHECK,
                payload: {
                    QRSession: sessionData,
                },
            });

            if (response.sessionID) {
                localStorage.setItem("QRSessionData", JSON.stringify(sessionData));
                if (userData) localStorage.setItem("user", JSON.stringify(userData));
            }

            return response;
        },
        (error) => {
            const messageError = getErrorMessage(error);
            console.log(messageError);

            dispatch({
                type: QR_SESSION_CHECK_FAIL,
            });

            return Promise.reject();
        });
}

export const getLatestOpenRoom = (QRSessionID) => (dispatch) => {
    console.log("getting latest open room id");
    return AuthService.getLatestRoomID(QRSessionID).then(
        (response) => {

            dispatch({
                type: GET_LATEST_OPEN_ROOM_ID,
                payload: {
                    roomID: response.roomID,
                    roomPin: response.roomPin,
                },
            });

            return response;
        },
        (error) => {
            const messageError = getErrorMessage(error);
            console.log(messageError);

            dispatch({
                type: GET_LATEST_OPEN_ROOM_ID_FAILED,
            });

            return Promise.reject();
        });
}

export const autoLoginQRSession = (QRSessionID, UserID, originSessionType, forceLogin = false) => (dispatch) => {
    console.log("Auto Login QR Session", forceLogin ? "(forceLogin)" : "");
    // The caller (phone/controller) is already authenticated. This call authorises the QR session
    // so the scanned HOST device can pick up a token. We must NOT touch the caller's auth state or
    // localStorage user token here — otherwise the caller starts acting under the host's session
    // (and logging out on the phone would kill the host session instead of its own).
    return AuthService.autoLoginQRSession(QRSessionID, UserID, originSessionType, forceLogin).then(
        (response) => {
            // Mirror login() — surface the SessionConflict so the UI can prompt the user
            // to confirm kicking the existing same-type session before retrying with ForceLogin.
            if (response && response.status === "SessionConflict") {
                dispatch({
                    type: SESSION_CONFLICT,
                    payload: {
                        message: response.message,
                        activeSessions: response.activeSessions,
                        sessionType: response.sessionType,
                    },
                });
                return Promise.reject("SessionConflict");
            }
            return response;
        },
        (error) => {
            const messageError = getErrorMessage(error);
            console.log(messageError);

            dispatch({
                type: QR_SESSION_LOGIN_FAIL,
            });

            return Promise.reject();
        });
}

export const sessionEnded = (message) => (dispatch) => {
    AuthService.logout();

    const reduxStore = Store.getState();
    if (reduxStore.room.roomOpen && reduxStore.room.isHost) {
        dispatch(leaveRoom());
    }

    dispatch({
        type: SESSION_ENDED,
        payload: { message },
    });
};

export const forceLogin = (req) => (dispatch) => {
    return dispatch(login({ ...req, forceLogin: true }));
};

export const clearSessionConflict = () => (dispatch) => {
    dispatch({ type: SESSION_CONFLICT_CLEAR });
};

export const clearSessionEndedMessage = () => (dispatch) => {
    dispatch({ type: SESSION_ENDED_CLEAR });
};

export const logout = () => (dispatch) => {
    AuthService.logout();

    const reduxStore = Store.getState();
    if (reduxStore.room.roomOpen && reduxStore.room.isHost) {
        dispatch(leaveRoom());
    }

    dispatch({
        type: LOGOUT,
    });

    //history.push('/');
};

export const setGames = (games) => (dispatch) => {
    const reduxStore = Store.getState();
    const updatedUser = { ...reduxStore.auth.user, games}
    dispatch({
        type: SET_GAMES,
        payload: updatedUser
    });

    //history.push('/');
};


export const impersonateLogin = (userData) => (dispatch) => {
    // Store impersonated user data in localStorage
    const userWithFlag = { ...userData, isImpersonated: true };
    localStorage.setItem("user", JSON.stringify(userWithFlag));

    dispatch({
        type: IMPERSONATE_LOGIN,
        payload: { user: userWithFlag },
    });
};

export const impersonateLogout = () => (dispatch) => {
    // Clear user data from localStorage
    localStorage.removeItem("user");
    localStorage.removeItem("games");

    dispatch({
        type: IMPERSONATE_LOGOUT,
    });
};

const getErrorMessage = (error) => {
    return (error.response &&
            error.response.data &&
            error.response.data.message) ||
        error.message ||
        error.toString();
}